<template>
  <v-dialog max-width="650" v-model="dialog.show">
    <v-card>
      <v-card-title>
        <div class="title">{{ $vuetify.lang.t(dialog.title) }}</div>
      </v-card-title>
      <v-divider></v-divider>
      <v-form @submit.prevent="sendForm">
        <v-card-text>
          <v-container>
            <v-row wrap>
              <v-col class="mb-0 py-0" cols="12" sm="12">
                <v-text-field
                  :error="!_.isNull(apiFormErrors['password'])"
                  :error-messages="
                    !_.isEmpty(errorsOldPassword)
                      ? errorsOldPassword
                      : apiFormErrors['old_password']
                  "
                  :label="
                    $vuetify.lang.t('$vuetify.profile.cols.old_password.title')
                  "
                  @blur="$v.form.old_password.$touch()"
                  @input="$v.form.old_password.$touch()"
                  autocomplete="off"
                  prepend-icon="mdi-shield-account-outline"
                  type="password"
                  v-model="form.old_password"
                ></v-text-field>
              </v-col>
              <v-col class="mb-0 py-0" cols="12" sm="6">
                <v-text-field
                  :error="!_.isNull(apiFormErrors['password'])"
                  :error-messages="
                    !_.isEmpty(errorsPassword)
                      ? errorsPassword
                      : apiFormErrors['password']
                  "
                  :label="
                    $vuetify.lang.t('$vuetify.profile.cols.password.title')
                  "
                  @blur="$v.form.password.$touch()"
                  @input="$v.form.password.$touch()"
                  autocomplete="off"
                  prepend-icon="mdi-shield-account-outline"
                  type="password"
                  v-model="form.password"
                ></v-text-field>
              </v-col>
              <v-col class="mb-0 py-0" cols="12" sm="6">
                <v-text-field
                  :error="!_.isNull(apiFormErrors['repeatPassword'])"
                  :error-messages="
                    !_.isEmpty(errorsRepeatPassword)
                      ? errorsRepeatPassword
                      : apiFormErrors['repeatPassword']
                  "
                  :label="
                    $vuetify.lang.t(
                      '$vuetify.profile.cols.repeat_password.title'
                    )
                  "
                  @blur="$v.form.repeatPassword.$touch()"
                  @input="$v.form.repeatPassword.$touch()"
                  autocomplete="off"
                  prepend-icon="mdi-shield-account-outline"
                  type="password"
                  v-model="form.repeatPassword"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog.show = false" text>{{
            $vuetify.lang.t("$vuetify.btn.close")
          }}</v-btn>
          <v-btn :loading="loadingBtn" color="secondary" text type="submit"
            >{{ $vuetify.lang.t(dialog.saveBtnTitle) }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import FormMixin from "../../mixins/Common/Forms";
import {
  required,
  maxLength,
  sameAs,
  minLength
} from "vuelidate/lib/validators";
import URLPath from "../../helpers/URL";

export default {
  name: "ChangePassword",
  mixins: [FormMixin],
  props: {
    dialog: {
      type: Object,
      default: function() {
        return {
          title: "$vuetify.profile.password.title",
          show: false,
          saveBtnTitle: "$vuetify.btn.save",
          action: "create"
        };
      }
    },
    form: {
      type: Object,
      default: function() {
        return {
          old_password: null,
          password: null,
          repeatPassword: null
        };
      }
    }
  },
  validations() {
    let validators = {
      form: {
        old_password: {
          required,
          minLength: minLength(5),
          maxLength: maxLength(50)
        },
        password: {
          minLength: minLength(5),
          maxLength: maxLength(50),
          required
        },
        repeatPassword: { sameAs: sameAs("password") }
      }
    };
    return validators;
  },
  data: () => ({
    loadingBtn: false
  }),
  methods: {
    sendForm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let self = this;
        this.loadingBtn = true;
        this.save(this.getFormParam())
          .then(() => {
            self.logout();
          })
          .catch(() => {
            this.$forceUpdate();
          })
          .finally(() => {
            self.loadingBtn = false;
          });
      }
    },
    logout: function() {
      const tokenName = process.env.VUE_APP_TOKEN_NAME;
      let self = this;
      let params = {
        url: URLPath.SECURITY.LOGOUT.URI,
        method: URLPath.SECURITY.LOGOUT.METHOD,
        data: {
          refresh_token: JSON.parse(this.$auth.token(tokenName)).refresh_token
        }
      };
      this.$store
        .dispatch("request", params)
        .then(() => {
          self.$auth.token(null);
          self.$router.push({ name: "login" });
        })
        .catch(() => {
          self.$store.dispatch("setNotification", {
            status: true,
            message: this.$vuetify.lang.t("$vuetify.error_occured")
          });
        });
    },
    getFormParam() {
      let params = {};
      params["url"] = URLPath.USER.PASSWORD.URI;
      params["data"] = this._.omit(this.form, ["repeatPassword"]);
      params["method"] = URLPath.USER.PASSWORD.METHOD;
      return params;
    }
  },
  computed: {
    errorsOldPassword() {
      let errors = [];
      if (!this.$v.form.old_password.$dirty) return errors;

      !this.$v.form.old_password.required &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.profile.cols.old_password.required")
        );

      !this.$v.form.old_password.minLength &&
        errors.push(
          this.$vuetify.lang.t(
            "$vuetify.profile.cols.old_password.length",
            [5],
            [50]
          )
        );

      !this.$v.form.old_password.maxLength &&
        errors.push(
          this.$vuetify.lang.t(
            "$vuetify.profile.cols.old_password.length",
            [5],
            [50]
          )
        );

      return errors;
    },
    errorsPassword() {
      let errors = [];
      if (!this.$v.form.password.$dirty) return errors;

      !this.$v.form.password.required &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.profile.cols.password.required")
        );

      !this.$v.form.password.minLength &&
        errors.push(
          this.$vuetify.lang.t(
            "$vuetify.profile.cols.password.length",
            [5],
            [50]
          )
        );

      !this.$v.form.password.maxLength &&
        errors.push(
          this.$vuetify.lang.t(
            "$vuetify.profile.cols.password.length",
            [5],
            [50]
          )
        );

      return errors;
    },
    errorsRepeatPassword() {
      let errors = [];
      if (this.dialog.action === "edit") return errors;
      if (!this.$v.form.repeatPassword.$dirty) return errors;

      !this.$v.form.repeatPassword.sameAs &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.profile.cols.repeat_password.sameAs")
        );

      return errors;
    }
  }
};
</script>

<style scoped></style>
